function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__ic_smartphone-a",
  d: "M16.5 0h-9A2.503 2.503 0 0 0 5 2.5v19C5 22.878 6.122 24 7.5 24h9c1.378 0 2.5-1.122 2.5-2.5v-19C19 1.122 17.878 0 16.5 0zm-1 2a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm-4 0h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1zm-2 20h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zm7 0h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1zm1.5-3H6V5h12v14z"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__ic_smartphone-a"
});

var SvgIcSmartphone = function SvgIcSmartphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSmartphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_smartphone.f11f13e4.svg";
export { ForwardRef as ReactComponent };